/* eslint-disable @typescript-eslint/no-explicit-any */
// Generates a unique id for any javascript value
const objList: any[] = []

export default function(obj: any, prefix = 'uid'): string {
  const index = objList.indexOf(obj)
  if (index === -1) {
    objList.push(obj)
    return `${prefix}${objList.length - 1}`
  } else {
    return `${prefix}${index}`
  }
}
